// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"vw_a bhg_b bhg_wb"};